import {
  type CreatePulseMutation,
  type CreatePulseMutationVariables,
  type PulseRefFragment,
  type PulseV1PulseInput,
  PulsesDocument,
  isError,
  useCreatePulseMutation,
  withStandardCreateHook,
} from '@spotify/confidence-graphql';

export const useCreatePulse = withStandardCreateHook<
  CreatePulseMutation,
  PulseRefFragment,
  'createPulse',
  CreatePulseMutationVariables,
  [PulseV1PulseInput, string | undefined]
>(
  useCreatePulseMutation,
  'createPulse',
  (pulse, pulseId) => ({
    pulse,
    ...(pulseId ? { pulseId } : {}),
  }),
  {
    update: (cache, { data }) => {
      const newPulse = data?.createPulse;
      if (!newPulse || isError(newPulse)) return;

      const existing = cache.readQuery({
        query: PulsesDocument,
      }) as {
        pulses?: {
          __typename: string;
          pulses: PulseRefFragment[];
          nextPageToken?: string | null;
        };
      } | null;

      if (!existing?.pulses) return;

      cache.writeQuery({
        query: PulsesDocument,
        data: {
          pulses: {
            ...existing.pulses,
            pulses: [newPulse, ...existing.pulses.pulses],
          },
        },
      });
    },
  },
);
